if (!global._babelPolyfill) {
    require('babel-polyfill');
}

import './styles/main.scss';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'

import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue from 'vue';
import App from './App.vue';

import AsyncComputed from 'vue-async-computed';

Vue.use(AsyncComputed);
Vue.use(ElementUI,{ locale });

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);

new Vue({
    el: '#razz-re-search-tool',
    components: { App },
    render: h => h(App),
});